import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import MiniCart from "./components/MiniCart";
import SalesPopup from "./components/popups/SalesPopup";


// Pages
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductPage from "./pages/ProductPage";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Contact from "./pages/Contact";
import B2B from "./pages/B2B";
import CategoryPage from "./pages/CategoryPage";
import Account from "./pages/Account";
import Profile from "./pages/Profile";
import Orders from "./pages/Orders";
import Addresses from "./pages/Addresses";
import AboutPage from "./pages/AboutPage";
import TestAPI from "./pages/TestAPI";
import PrivacyPolicy from "./pages/PrivacyPolicy";
// Context
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import FloatingSupport from "./components/FloatingSupport";
import AISalesChat from "./components/AISalesChat";
import "./components/Footer.css";

function App() {
  const [search, setSearch] = useState("");

  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <SalesPopup />
          
          {/* HEADER */}
          <Navbar onSearch={setSearch} />

          <Routes>
            {/* 1. Static Routes (Sabse Pehle) */}
            <Route path="/" element={<Home search={search} />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/account" element={<Account />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/addresses" element={<Addresses />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/b2b" element={<B2B />} />
           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/test" element={<TestAPI />} />

            {/* 2. Dynamic Routes (Baad Mein) */}
            <Route path="/product" element={<ProductPage />} />
            <Route path="/product/:slug" element={<ProductPage />} />
            <Route path="/category" element={<CategoryPage />} />
            <Route path="/category/:category" element={<CategoryPage />} />

            {/* 3. Fallback Route (Agar kuch match na ho) */}
            <Route path="*" element={
              <div style={{ textAlign: "center", padding: "100px 20px" }}>
                <h1>404 - Page Not Found</h1>
                <p>Opps! The page you are looking for does not exist.</p>
                <a href="/" style={{ color: "red", fontWeight: "bold" }}>Go Back Home</a>
              </div>
            } />
          </Routes>

          {/* SHARED COMPONENTS */}
          <MiniCart />
          <FloatingSupport />
          <AISalesChat />
          <Footer />
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;